import { usePostAPI, useDeleteAPI, usePatchAPI } from '@api/useAPI';
import {
	AJAXError,
	APICallProps,
} from '@types';

export const useApproveRateCards = () => {
	const {
		isLoading,
		data,
		clearData,
		error,
		clearError,
		callAPI
	} = usePatchAPI({
		endpoint: '/api/lanes/customer/approve',
		domain: 'ShipmentAPI'
	});

	return {
		loadingApproveRateCards: isLoading,
		approveRateCardsData: data as any,
		approveRateCardsError: error as AJAXError,
		clearApproveRateCardsError: clearError,
		clearApproveRateCardsData: clearData,
		callApproveRateCards: callAPI as (props?: APICallProps) => Promise<{
			data: any | null;
			error: AJAXError | null
		}>
	};
};

export const useBulkUpdateFuelLevy = () => {
	const {
		isLoading,
		data,
		clearData,
		error,
		clearError,
		callAPI
	} = usePostAPI({
		endpoint: '/api/fuel-levy-tariff/bulk',
		domain: 'ShipmentAPI'
	});

	return {
		loadingBulkUpdate: isLoading,
		bulkUpdate: data as any,
		bulkUpdateError: error as AJAXError,
		clearBulkUpdateError: clearError,
		clearBulkUpdateData: clearData,
		callBulkUpdateFuelLevies: callAPI as (props?: APICallProps) => Promise<{
            data: any | null;
            error: AJAXError | null
        }>
	}
}

export const useDeleteRateCard = () => {
	const {
		isLoading,
		data,
		clearData,
		error,
		clearError,
		callAPI
	} = useDeleteAPI({
		endpoint: '/api/lanes/{1}',
		domain: 'ShipmentAPI'
	});

	return {
		loadingDeleteRC: isLoading,
		deleteRC: data as any,
		deleteRcError: error as AJAXError,
		clearDeleteRCError: clearError,
		clearDeleteRCData: clearData,
		callDeleteRateCard: callAPI as (props?: APICallProps) => Promise<{
            data: any | null;
            error: AJAXError | null
        }>
	}
}

export const useBulkDeleteRateCards = () => {
	const {
		isLoading,
		data,
		clearData,
		error,
		clearError,
		callAPI
	} = useDeleteAPI({
		endpoint: '/api/lanes/bulk',
		domain: 'ShipmentAPI'
	});

	return {
		loadingBulkDeleteRateCards: isLoading,
		deleteRateCards: data as any,
		deleteRateCardsError: error as AJAXError,
		clearDeleteRateCardsError: clearError,
		clearDeleteRateCardsData: clearData,
		callBulkDeleteRateCards: callAPI as (props?: APICallProps) => Promise<{
			data: any | null;
			error: AJAXError | null
		}>
	}
}

/** Deletes one scheduled Tariff off a Fuel levy, not the levy itself. */
export const useDeleteScheduledFuelLevy = () => {
	const {
		isLoading,
		data,
		clearData,
		error,
		clearError,
		callAPI
	} = useDeleteAPI({
		endpoint: '/api/fuel-levy-tariff/{1}',
		domain: 'ShipmentAPI'
	});

	return {
		loadingDeleteScheduledFuelLevy: isLoading,
		deleteScheduledFuelLevy: data as any,
		deleteScheduledFuelLevyError: error as AJAXError,
		clearDeleteScheduledFuelLevyError: clearError,
		clearDeleteScheduledFuelLevyData: clearData,
		callDeleteScheduledFuelLevy: callAPI as (props?: APICallProps) => Promise<{
            data: any | null;
            error: AJAXError | null
        }>
	}
}
